<template>
  <div class="bg-body rounded p-5 mb-5">
    <div class="row mb-5">
      <div class="col-lg-2 mb-5 mb-lg-0">
        <date-field
          v-model="form.fromDate"
          :required="true"
          id="orderFilter.fromDate"
          name="orderFilter.fromDate"
          placeholder="Дата начало"
        />
      </div>
      <div class="col-lg-2 mb-5 mb-lg-0">
        <date-field
          v-model="form.toDate"
          :required="true"
          id="orderFilter.toDate"
          name="orderFilter.toDate"
          placeholder="Дата конца"
        />
      </div>
      <div class="col-lg-3 mb-5 mb-lg-0">
        <input-field
          v-model="form.userId"
          id="form.userId"
          name="form.userId"
          :required="true"
          placeholder="ID Клиента"
          type="text"
          mb="5"
        />
      </div>
      <div class="col-lg-2 mb-5 mb-lg-0">
        <div class="custom-select dynamic w-100">
          <label for="orderFilter.status" class="required">Статус</label>
          <v-select
            v-model="form.status"
            input-id="orderFilter.status"
            :options="statuses"
            :disabled="!statuses.length"
            :reduce="item => item.code"
            :required="true"
            placeholder="Выберите..."
            class="bg-gray-100 form rounded"
            label="descr"
          />
        </div>
      </div>
      <div class="col-lg-3 mb-5 mb-lg-0">
        <div class="custom-select dynamic w-100">
          <label v-if="stations" for="orderFilter.pointCode" class="required">Локация</label>
          <v-select
            v-if="stations"
            :loading="!stations"
            v-model="form.pointCode"
            input-id="orderFilter.pointCode"
            :options="stations"
            :disabled="!stations.length"
            :reduce="item => item.id"
            :required="true"
            placeholder="Выберите..."
            class="bg-gray-100 form rounded"
            label="label"
          />
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-between flex-column flex-lg-row">
      <div class="d-flex justify-content-between">
        <div @click="reset" class="btn btn-sm btn-light-danger me-2">Сбросить</div>
        <div @click="search" class="btn btn-sm btn-primary">Поиск</div>
      </div>
    </div>
  </div>
</template>

<script>
import DateField from '@/components/Fields/DateField'
import vSelect from 'vue-select'
import axios from 'axios'
import {notify} from '@kyvg/vue3-notification'
import InputField from "@/components/Fields/InputField.vue";

export default {
  name: 'OrdersFilter',
  components: {InputField, vSelect, DateField},
  props: {
    statuses: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      form: {
        fromDate: '',
        toDate: '',
        status: null,
        pointCode: null,
        userId: null,
      },
      stations: null,
      loading: false
    }
  },
  mounted() {
    this.getStations()
  },
  methods: {
    getStations() {
      this.loading = true;
      axios.get('partner-branching-service/api/v1/partners/points', {
        params: {page: 0, size: 500,},
      })
        .then(res => {
          if (res.data?.content?.length >= 0) {
            this.stations = res.data.content;
          } else {
            notify({
              duration: 7000,
              type: 'error',
              speed: 1000,
              title: 'Ошибка',
              text: 'Что-то пошло не так!',
            });
          }
        })
        .catch(error => {
          notify({
            duration: 7000,
            type: 'error',
            speed: 1000,
            title: 'Ошибка',
            text: error?.response?.data?.errorDescription ?? error.message,
          });
        })
        .finally(() => {
          this.loading = false
        });
    },
    toUnix(dateStr, isEnd = false) {
      const date = new Date(`${dateStr}T00:00:00+05:00`);
      if (isEnd) { date.setDate(date.getDate() + 1) }
      return date.getTime();
    },
    search() {
      this.$emit('search', this.form);
    },
    reset() {
      this.form = {
        fromDate: '',
        toDate: '',
        status: null,
        pointCode: null,
      }
      this.$emit('search', null);
    }
  }
}
</script>

<style scoped>

</style>


